import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

const QuickTooltip = ({
  text,
  children,
  triggerClassname,
  side = "top",
  align = "center",
}: {
  text: string | JSX.Element;
  children: React.ReactNode;
  triggerClassname?: string;
  side?: "top" | "bottom" | "left" | "right";
  align?: "start" | "center" | "end";
}) => {
  return (
    <TooltipProvider delayDuration={100}>
      <Tooltip>
        <TooltipTrigger className={triggerClassname}>
          <span className="underline underline-offset-4">{children}</span>
        </TooltipTrigger>
        <TooltipContent side={side} align={align}>
          {text}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default QuickTooltip;
